import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	spotlightDismiss: {
		id: 'upgrade-onboarding-experiment.spotlight.spotlight-dismiss',
		defaultMessage: 'Dismiss',
		description: 'Text for button to dismiss spotlight that is highlighting another button',
	},
	spotlightHeading: {
		id: 'upgrade-onboarding-experiment.spotlight.spotlight-heading',
		defaultMessage: 'Trial and plan info',
		description: 'Text for button to dismiss spotlight that is highlighting another button',
	},
	spotlightBody: {
		id: 'upgrade-onboarding-experiment.spotlight.spotlight-body',
		defaultMessage:
			'See how many trial days you have left, and learn more about the Standard plan here.',
		description: 'Text for button to dismiss spotlight that is highlighting another button',
	},
});
